<template>
  <div class="d-flex align-center justify-center fill-height">
    <v-card min-width="400">
      <v-toolbar color="primary" max-height="64">
        <v-toolbar-title class="mx-5 altfont" v-if="model && !isSmallScreen">{{ model.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          v-if="isAdmin && !isResourcePublished"
          icon
          variant="plain"
          color="warning"
          v-tooltip.bottom-center="$t('cortona.ipc.resource-not-published', { status: props.model && props.model.status })"
          class="d-print-none"
        >
          <v-icon>mdi-alert-outline</v-icon>
        </v-btn>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="d-flex flex-column align-center justify-center py-10 ga-4">
        <v-icon size="64" color="grey-lighten-1">mdi-file-alert-outline</v-icon>

        <div class="text-h6 text-medium-emphasis">{{ $t('resource-preview.unsupported.title') }}</div>
        <div class="text-body-2 text-medium-emphasis">{{ model.mimeType }}</div>

        <v-btn
          v-if="model.path"
          color="primary"
          variant="tonal"
          prepend-icon="mdi-download-box-outline"
          class="mt-2"
          @click="download"
        >
          {{ $t('resource-preview.unsupported.download') }}
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useDisplay } from 'vuetify';
import { useAccountStore } from '@/stores/account';

const props = defineProps<{
  model?: any;
}>();

const emit = defineEmits<{
  closeDialog: [];
}>();

const { width } = useDisplay();
const accountStore = useAccountStore();

const isSmallScreen = computed(() => width.value < 768);
const isAdmin = computed(() => accountStore.account?.userType === 'ADMIN');
const isResourcePublished = computed(() => !props.model || props.model.status === 'PUBLISHED');

const closeDialog = () => emit('closeDialog');

const download = () => window.open(props.model.path, '_self');
</script>

<style lang="scss" scoped>
.altfont {
  font-family: 'Saira Semi Condensed', sans-serif;
  font-size: 1.5rem !important;
}
</style>
